import React, { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormTextField, Stack } from "sprint-common-web";

import { useCreateDistributorForm } from "./useCreateDistributorForm";

export interface CreateDistributorFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export interface CreateDistributorFormInputs {
    name: string;
    alias?: string;
}

export const CreateDistributorForm: FunctionComponent<CreateDistributorFormProps> = (
    props: CreateDistributorFormProps
) => {
    const { errors, control, formState, reset, handleSubmit } = useForm<CreateDistributorFormInputs>({
        defaultValues: {
            name: "",
            alias: ""
        },
        criteriaMode: "all"
    });

    const { createDist } = useCreateDistributorForm();

    const handleCreateDistributor = async (inputs: CreateDistributorFormInputs) => {
        await createDist(inputs);
        props.onSubmit();
        reset();
    };

    const handleCancelButtonClick = () => {
        reset();
        props.onCancel();
    };

    return (
        <Stack>
            <Form onSubmit={handleSubmit(handleCreateDistributor)}>
                <Stack verticalAlign="space-between">
                    <FormFields>
                        <FormTextField
                            label="Name"
                            control={control}
                            name="name"
                            errors={errors}
                            rules={{
                                required: "Name is required field"
                            }}
                        />
                        <Stack>
                            <FormTextField label="Alias" control={control} name="alias" errors={errors} />
                        </Stack>
                    </FormFields>
                    <FormActions
                        isLoading={formState.isSubmitting || formState.isValidating}
                        onCancel={handleCancelButtonClick}
                    />
                </Stack>
            </Form>
        </Stack>
    );
};
